import Main from '@/components/layout/main'

import UserList from '@/views/user/user'
import UserTemplateList from '@/views/user/template'
import IndustryList from '@/views/industry'
import BannerList from '@/views/banner'
import FontList from '@/views/font'
import FeedbackList from '@/views/feedback'
import OfficialTemplateCategotyList from '@/views/official-templates/categories'
import OfficialTemplatesList from '@/views/official-templates/templates'
import GoodsList from '@/views/mall/goods'
import CategoryList from '@/views/mall/categories'
import SubCategoryList from '@/views/mall/sub-categories'
import StandardList from '@/views/mall/standards'
import IconCategoryList from '@/views/icons/categories'
import IconList from '@/views/icons/icon'
import FaqCategoryList from '@/views/faq/categories'
import AppList from '@/views/app'
import FaqList from '@/views/faq/content'

/** 需要登录权限的路由 */
const routers = setInMenu([
  {
    path: 'user',
    meta: {
      title: '用户管理',
      icon: 'app'
    },
    redirect: {
      name: '/user/list'
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: '/user/list',
        meta: {
          title: '用户列表',
          inMenu: false
        },
        component: UserList
      },
      {
        path: 'template/list',
        name: '/user/template/list',
        meta: {
          title: '用户模板列表',
          inMenu: false
        },
        component: UserTemplateList
      }
    ]
  },
  {
    path: 'industry',
    meta: {
      title: '行业管理',
      icon: 'app'
    },
    redirect: {
      name: '/industry/list'
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: '/industry/list',
        meta: {
          title: '行业列表',
          inMenu: false
        },
        component: IndustryList
      }
    ]
  },
  {
    path: 'banner',
    meta: {
      title: '轮播图管理',
      icon: 'app'
    },
    redirect: {
      name: '/banner/list'
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: '/banner/list',
        meta: {
          title: '轮播图列表',
          inMenu: false
        },
        component: BannerList
      }
    ]
  },
  {
    path: 'font',
    meta: {
      title: '字体管理'
    },
    redirect: {
      name: '/font/list'
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: '/font/list',
        meta: {
          title: '字体列表',
          inMenu: false
        },
        component: FontList
      }
    ]
  },
  {
    path: 'feedback',
    meta: {
      title: '反馈管理'
    },
    redirect: {
      name: '/feedback/list'
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: '/feedback/list',
        meta: {
          title: '反馈列表',
          inMenu: false
        },
        component: FeedbackList
      }
    ]
  },
  {
    path: 'official-templates',
    meta: {
      title: '官方模版管理'
    },
    redirect: {
      name: '/official-templates/list'
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: '/official-templates/list',
        meta: {
          title: '官方模版列表',
          inMenu: false
        },
        component: OfficialTemplatesList
      },
      {
        path: 'category/list',
        name: '/official-templates/category/list',
        meta: {
          title: '官方模板类型管理',
          inMenu: false
        },
        component: OfficialTemplateCategotyList
      }
    ]
  },
  {
    path: 'icons',
    meta: {
      title: '图标管理'
    },
    redirect: {
      name: '/icons/icon/list'
    },
    component: Main,
    children: [
      {
        path: 'category/list',
        name: '/icons/category/list',
        meta: {
          title: '图标分类管理',
          inMenu: false
        },
        component: IconCategoryList
      },
      {
        path: 'icon/list',
        name: '/icons/icon/list',
        meta: {
          title: '图标列表',
          inMenu: false
        },
        component: IconList
      }
    ]
  },
  {
    path: 'mall',
    meta: {
      title: '商城管理'
    },
    redirect: {
      name: '/goods/list'
    },
    component: Main,
    children: [
      {
        path: 'goods/list',
        name: '/mall/goods/list',
        meta: {
          title: '商品列表',
          inMenu: false
        },
        component: GoodsList
      },
      {
        path: 'category/list',
        name: '/mall/category/list',
        meta: {
          title: '一级分类列表',
          inMenu: false
        },
        component: CategoryList
      },
      {
        path: 'sub-category/list',
        name: '/mall/sub-category/list',
        meta: {
          title: '二级分类列表',
          inMenu: false
        },
        component: SubCategoryList
      },
      {
        path: 'standards/list',
        name: '/mall/standards/list',
        meta: {
          title: '规格列表',
          inMenu: false
        },
        component: StandardList
      }
    ]
  },
  {
    path: 'app-version',
    meta: {
      title: '客户端版本管理',
      icon: 'app'
    },
    redirect: {
      name: '/app-version/list'
    },
    component: Main,
    children: [
      {
        path: 'list',
        name: '/app-version/list',
        meta: {
          title: '客户端版本列表',
          inMenu: false
        },
        component: AppList
      }
    ]
  },
  {
    path: 'faq',
    meta: {
      title: '帮助中心管理'
    },
    redirect: {
      name: '/faq/content/list'
    },
    component: Main,
    children: [
      {
        path: 'category/list',
        name: '/faq/category/list',
        meta: {
          title: '分类管理',
          inMenu: false
        },
        component: FaqCategoryList
      },
      {
        path: 'content/list',
        name: '/faq/content/list',
        meta: {
          title: '内容管理',
          inMenu: false
        },
        component: FaqList
      }
    ]
  }
])

function setInMenu (data) {
  if (Array.isArray(data)) {
    return data.map(ob => {
      if (typeof ob === 'object') {
        return caseDataObject (ob)
      }
    })
  } else if (typeof data === 'object') {
    return caseDataObject (data)
  }
}

function caseDataObject  (data) {
  try {
    if (data.hasOwnProperty('meta')) {
      if (!data.meta.hasOwnProperty('inMenu')) {
        data.meta.inMenu = true
      }
    } else {
      data.meta = {
        inMenu: true
      }
    }
    data.hasOwnProperty('children') && setInMenu(data.children)
  } catch (e) {
    console.error(e)
  }
  return data
}

export default routers
